import { render, staticRenderFns } from "./ContentfulVideo.vue?vue&type=template&id=0a814b5e&"
import script from "./ContentfulVideo.vue?vue&type=script&lang=js&"
export * from "./ContentfulVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports